import { render, staticRenderFns } from "./ModalChangeTheme.vue?vue&type=template&id=6fc54485&scoped=true"
import script from "./ModalChangeTheme.vue?vue&type=script&lang=js"
export * from "./ModalChangeTheme.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeTheme.vue?vue&type=style&index=0&id=6fc54485&prod&lang=scss"
import style1 from "./ModalChangeTheme.vue?vue&type=style&index=1&id=6fc54485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc54485",
  null
  
)

export default component.exports